import { render, staticRenderFns } from "./DeliveryList.vue?vue&type=template&id=0b8cadc8&lang=pug&"
import script from "./DeliveryList.vue?vue&type=script&lang=ts&"
export * from "./DeliveryList.vue?vue&type=script&lang=ts&"
import style0 from "./DeliveryList.vue?vue&type=style&index=0&id=0b8cadc8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports